import { md5, addToCart, chunkArray, formatMoney } from "@root/_utils";
import { DigitalStepMap } from "../Proxy/pages/GiftCardForm/_schema";
import { getCart } from '@root/_utils';

// Customer: Digital Gift Card Form Schema
export const digitalSchema = {
  id: null,
  properties: {
    _gcp_selected_card_image: "",
    _gcp_recipient_email: "",
    _gcp_recipient_phone: "",
    _gcp_recipient_name: "",
    _gcp_delivery_time: "",
    _gcp_delivery_date: "",
    _gcp_delivery_timezone: "",
    _gcp_message_from: "",
    _gcp_message_salutation: "",
    _gcp_message_font_family: "",
    _gcp_signature_font_family: "",
    _gcp_message_text: "",
  }
};


export class AddToCartException extends Error {
  constructor(data) {
    super(data.message);
    this.errors = data.errors;
    this.name = "AddToCartException";
    // super(`${zip} does not conform to the expected format for a zip code`);
  }
}


export const bULKOU = {

  settings: null,

  requestsComplete: 0,

  totalRequests: 0,

  amountChoices: [],

  progressBar: null,

  conversionSurcharge: 0,

  pricingConfig: null,

  currency: null,

  timer: () =>  {
    var startTimes = {}; // multiple start times will be stored here

    return {
      start: function (id) {
        id = id || 'default'; // set id = 'default' if no valid argument passed
        startTimes[id] = +new Date; // store the current time using the timer id
      },
      stop: function (id) {
        id = id || 'default';
        var diff = (+new Date - startTimes[id]); // get the difference
        delete startTimes[id]; // remove the stored start time
        return diff || undefined; // return the difference in milliseconds
      }
    };
  },

  /**
   * Navigate to the correct step in the form view.
   */
  updateStep: (fieldName) => {

    if (!fieldName || DigitalStepMap.length === 0) return;

    const matchingStep = DigitalStepMap.find((step) => step.values.indexOf(fieldName) > -1);

    if (matchingStep && matchingStep.name) {
      return bULKOU.goToStep(matchingStep.name);
    }

    console.warn("Could not find a form step matching field " + fieldName);

  },

  /**
     * Navigate to a particular step in the form
     * @param {string} step
     */
  goToStep: (step) => {

    let paramString = `?step=${step}`;
    const urlParams = new URLSearchParams(window.location.search);

    for (const [key, value] of urlParams.entries()) {
      if (key !== "step") {
        paramString += `&${key}=${value}`;
      }
    }

    window.GCPSDK.navigate(`${window.location.pathname}${paramString}`);

  },

  dataToObjects: (data) => {

    const requests = [];

    data.forEach((row) => {

      const baseRow = JSON.parse(JSON.stringify(digitalSchema));
      
      Object.entries(row.data).forEach(([key, columnValue]) => {

        const columnName = key.replaceAll("__", ".");
        const nameParts  = columnName.split(".");

        if (nameParts.includes("properties")) {
          baseRow.properties[nameParts[1]] = columnValue;
        } else {
          baseRow[nameParts[0]] = columnValue;
        }

        if (nameParts.includes("_gcp_recipient_email")) {
          baseRow.properties[bULKOU.settings.translations.purchase.recipient_email_label] = columnValue;
        }

      });

      baseRow.properties._gcp_locale = (typeof Shopify !== "undefined" && Shopify.locale) ? Shopify.locale : "";
      baseRow.properties._gcp_fulfillment_type = "digital";
      baseRow.properties._gcp_currency  = bULKOU.currency.code;
      baseRow.properties._gcp_country = bULKOU.currency.country;

      baseRow.quantity = row.quantity || 1;

      requests.push(baseRow);

    });

    return JSON.parse(JSON.stringify(requests));

  },

  /**
   * Fake progres bar for draft order generation
   */
  beginFakeProgress: () => {

    let newPercentage = 0;

    let interval = setInterval(() => {

      newPercentage = newPercentage + 0.005;

      if (newPercentage > 1) {
        newPercentage = 1;
      }
      // bULKOU.progressBar.animate(newPercentage);

      if (newPercentage === 1) {
        clearInterval(interval);
      }

    }, 100);

  },

  addToCartProgressUpdate: () => {

    bULKOU.requestsComplete++;

    var percentage = bULKOU.requestsComplete / bULKOU.totalRequests;
    if (percentage > 1) {
      percentage = 1;
    }

    // bULKOU.progressBar.animate(percentage);  // Number from 0.0 to 1.0

  },

  addToCartProgressStart: () => {

    bULKOU.requestsComplete = 0;

    bULKOU.submittingModal = new swal({
      icon: 'info',
      title: "Submitting...",
      html:'<div class="gcProgressBar" data-stroke="data:ldbar/res,gradient(0,1,#f99,#ff9)"></div><p>' + bULKOU.settings.translations.bulk.please_wait_building + '</p>',
      //text: "This may take a while. Please do not close this page.",
      showConfirmButton: false,
      allowOutsideClick: false,
      showCancelButton: false,
      showClass: {
        backdrop: 'swal2-noanimation', // disable backdrop animation
        popup: '',                     // disable popup animation
        icon: ''                       // disable icon animation
      },
      width: 400
    });

    // bULKOU.progressBar = new ProgressBar.Line(".gcProgressBar", {
    //   strokeWidth: 4,
    //   easing: 'easeInOut',
    //   duration: 1400,
    //   color: '#FFEA82',
    //   trailColor: '#eee',
    //   trailWidth: 1,
    //   svgStyle: {width: '100%', height: '100%', display: 'block'},
    //   text: {
    //     style: {
    //       // Text color.
    //       // Default: same as stroke color (options.color)
    //       color: '#999',
    //       position: 'absolute',
    //       padding: 0,
    //       margin: 0,
    //       transform: null,
    //       left: 0,
    //       right: 0,
    //       top: 0,
    //       bottom: 0,
    //       'line-height': '20px',
    //     },
    //     autoStyleContainer: false
    //   },
    //   from: {color: '#FFEA82'},
    //   to: {color: '#ED6A5A'},
    //   step: (state, bar) => {
    //     bar.setText(Math.round(bar.value() * 100) + ' %');
    //   }
    // });

  },

  addToCartComplete: (draftOrder = null) => {

    if (draftOrder !== null && draftOrder.invoiceUrl) {
      window.location.href = draftOrder.invoiceUrl;
    } else if (draftOrder !== null && !draftOrder.invoiceUrl) { 
      alert("Something went wrong. Please try again");
    } else {
      window.location.href = "/checkout";
    }

  },

  /**
   * Generate a draft order from the table
   */
  createDraftOrder: (data) => {

    return new Promise((resolve, reject) => {

      const objects = bULKOU.dataToObjects(data);

      const request = {
        line_items: objects,
        currency: bULKOU.currency.active,
        country: bULKOU.currency.country,
      };

      fetch(`${window.Shopify?.routes?.root}a/gc/api/bulk-checkout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(request)
      })
      .then((r) => r.json())
      .then((res) => {
        resolve(res);
      })
      .catch(error => {
        console.warn("An error occurred creating the checkout", error);
        reject(bULKOU.settings.translations.bulk.checkout_error);
      });

    });

  },

  /**
   * Generate a draft order from the table
   */
  processGenerateDraftOrder: async (mergedRequests) => {

    try {

      const draftOrder = await bULKOU.createDraftOrder(mergedRequests);

      if (!draftOrder.invoiceUrl) {
        throw new AddToCartException({
          message: bULKOU.settings.translations.bulk.add_cart_error,
          errors: draftOrder?.errors || ["Something went wrong"]
        });
      } else {
        bULKOU.addToCartComplete(draftOrder);
      }

      
      
    } catch(e) {

      console.warn(e);
      alert("Something went wrong");
      bULKOU.submittingModal.close();

    }
   

    

  },

  /**
   * Add a chunk of items to the cart
   */
  addToCart: (data, errors = []) => {

    return new Promise((resolve, reject) => {

      const request = bULKOU.dataToObjects(data);

      addToCart({
        items: request
      })
      .then((r) => r.json())
      .then((res) => {

        setTimeout(() => {
          resolve(res);
        }, 1500);

      })
      .catch(error => {
        console.warn("An add to cart occurred", error);
        let errors = typeof(error.message) != 'undefined' ? [error.message] : [];
        throw new AddToCartException({
          message: bULKOU.settings.translations.bulk.add_cart_error,
          errors: errors
        });
      });

    });


  },

  /**
   * Add items to the cart chunk by chunk
   */
  processAddToCart: async (requestGroups) => {

    const dataChunk = requestGroups.shift();

    await bULKOU.addToCart(dataChunk);

    // bULKOU.addToCartProgressUpdate();

    if (!requestGroups.length) {
      bULKOU.addToCartComplete();
    } else {
      bULKOU.processAddToCart(requestGroups);
    }

  },

  /**
   * Merge duplicate line items and up the quantity
   */
  mergeRequests: (data) => {

    const newRequests = {};

    data.forEach((item, i) => {

      const fingerPrint = md5(JSON.stringify(item));

      if (!newRequests[fingerPrint]) {
        newRequests[fingerPrint] = {
          quantity: 1,
          data: item
        };
      } else {
        newRequests[fingerPrint].quantity = newRequests[fingerPrint].quantity + 1;
      }

    });

    return Object.values(newRequests);

  },

}
